import { gql } from "graphql-tag"

export const typeSort = gql`
  input Sort {
    orderBy: String
    direction: Direction
    caseSensitive: Boolean
  }

  enum Direction {
    asc
    desc
  }
`
